"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorAction = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _ErrorAction = require("./ErrorAction.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node.isRequired,
  onClick: _propTypes.func.isRequired
} : {};

var ErrorAction = function ErrorAction(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return (0, _core.jsx)(_ErrorAction.Button, {
    onClick: onClick
  }, children);
};

exports.ErrorAction = ErrorAction;
process.env.NODE_ENV !== "production" ? ErrorAction.propTypes = propTypes : void 0;
ErrorAction.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorAction",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};